import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, TemplateRef } from '@angular/core';

import { SelectController } from '../select-controller.service';
import { Select2Item, ItemContext } from '../types';

@Component({
  standalone: true,
  selector: 'rt-select-item-wrapper',
  template: ` <ng-template
    [ngTemplateOutlet]="templateOutlet()"
    [ngTemplateOutletContext]="templateOutletContext()"
  />`,
  host: {
    '(mouseenter)': 'onMouseEnter()',
  },
  imports: [NgTemplateOutlet],
})
export class ItemWrapperComponent {
  public templateOutlet = input.required<TemplateRef<any>>();
  public templateOutletContext = input.required<ItemContext<Select2Item>>();

  private selectController = inject(SelectController);

  public onMouseEnter() {
    this.selectController.navigation$.next({
      type: 'item',
      index: this.templateOutletContext().index,
    });
  }
}
